import { BlockReason, HardBlockReason } from '@generated-types';

export const DEBIT_HARD_BLOCK_REASONS = [
    BlockReason.LOST,
    BlockReason.STOLEN,
    BlockReason.DAMAGED,
    'NOT_IN_USE',
] as HardBlockReason[];
